/** `attempt_submissions.status`: in review until filed as an attempt. */
export enum AttemptSubmissionStatus {
  NeedsReview = 'needs_review',
  Submitted = 'submitted',
}

/** Why the reader held a sheet for review. Must match `attempt_submissions.review_reasons`. */
export enum AttemptSubmissionReviewReason {
  StudentUnreadable = 'student_unreadable',
  StudentNotFound = 'student_not_found',
  StudentAmbiguous = 'student_ambiguous',
  SetUnreadable = 'set_unreadable',
  SetNotFound = 'set_not_found',
  SetNotPublished = 'set_not_published',
  SetUnsupported = 'set_unsupported',
  NoQrCode = 'no_qr_code',
  PagesDisagree = 'pages_disagree',
  AnswersDisagree = 'answers_disagree',
  PossibleDuplicate = 'possible_duplicate',
  NoAnswers = 'no_answers',
  PageUnreadable = 'page_unreadable',
}

/** The ovals printed on each row of the response sheet, in order. */
export enum AnswerSheetLetter {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
}
